import styled from "styled-components";

import { colorsPalettes, setFontVariant, $dmSansFontFamily } from "@similarweb/styles";
import { FlexRow } from "@similarweb/ui-components";

export const StyledNewItemsListContainer = styled(FlexRow)`
    padding: 12px 16px;
    gap: 6px;

    &:hover {
        cursor: pointer;
        background: ${colorsPalettes.carbon[25]};
        border-radius: 6px;
    }
`;

export const StyledNewListItem = styled.span`
    ${setFontVariant("subsectionTitle", colorsPalettes.orange[400])};
    font-size: 12px;
`;

export const StyledNewListContent = styled.span`
    ${setFontVariant("dataTable2", colorsPalettes.carbon[250])};
    letter-spacing: 0.6px;
    font-family: ${$dmSansFontFamily};
    width: max-content;
    display: flex;
    align-items: center;
`;
